import moment from "moment";

/***
 * format returns a formatted string for the passed format name and value
 *
 * @param name
 * @param value
 * @returns {*}
 */
function format(name, value) {
    let result = value;
    let date;
    switch (name) {
        case 'date':
            date = moment(value);
            result = date.format('DD MMM  HH:mm:ss');
            break;

        case 'date-long':
            date = moment(value);
            result = date.format('D MMMM YYYY');
            break;

        case 'time-12h':
            date = moment(value);
            result = date.format('h:mm:ss') + '&nbsp;' + date.format('a');
            break;

        case 'time-12h-short':
            date = moment(value);
            result = date.format('h:mm') + '&nbsp;' + date.format('a');
            break;

        case 'ago':
            date = moment(value);
            result = moment.duration(moment().diff(date)).humanize() + ' ago';
            break;

        case 'date-only':
            date = moment(value);
            result = date.format('D MMM YY');
            break;

        case 'direction':
            if (value.indexOf('inbound')===0 || value.indexOf('Inbound')===0) {
                result = 'incoming';
            }
            break;

        case 'status':
            if (value === 'no-answer' || value === 'noanswer') {
                result = 'no answer';
            }
            break;

        case 'duration':
            let duration = moment.duration(value, 'seconds');
            let hr = duration.hours();
            let min = duration.minutes();
            let secs = duration.seconds();
            if (value > 0) {
                result = secs + 's';
                if (min > 0) { result = min + 'm ' + result; }
                if (hr > 0)  { result = hr + 'h '  + result; }
            } else {
                result = "—";
            }
            break;

        default:
            return result
    }
    return result
}

export default format